/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focal_Point_CropInputs */

const en_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focal Point Crop`)
};

const es_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorte de punto focal`)
};

const fr_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recadrage sur le point focal`)
};

const de_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokuspunkt-Zuschnitt`)
};

const ja_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーカルポイント切り抜き`)
};

const zh_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`焦点裁剪`)
};

const ar_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اقتطاع نقطة التركيز`)
};

const id_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potong Titik Fokus`)
};

const it_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritaglio punto focale`)
};

const ru_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кадрирование по точке фокуса`)
};

const pt_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corte do ponto focal`)
};

const ko_focal_point_crop = /** @type {(inputs: Focal_Point_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초점 자르기`)
};

/**
* | output |
* | --- |
* | "Focal Point Crop" |
*
* @param {Focal_Point_CropInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const focal_point_crop = /** @type {((inputs?: Focal_Point_CropInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focal_Point_CropInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focal_point_crop(inputs)
	if (locale === "es") return es_focal_point_crop(inputs)
	if (locale === "fr") return fr_focal_point_crop(inputs)
	if (locale === "de") return de_focal_point_crop(inputs)
	if (locale === "ja") return ja_focal_point_crop(inputs)
	if (locale === "zh") return zh_focal_point_crop(inputs)
	if (locale === "ar") return ar_focal_point_crop(inputs)
	if (locale === "id") return id_focal_point_crop(inputs)
	if (locale === "it") return it_focal_point_crop(inputs)
	if (locale === "ru") return ru_focal_point_crop(inputs)
	if (locale === "pt") return pt_focal_point_crop(inputs)
	return ko_focal_point_crop(inputs)
});